import type { MemorySummary, MemoryTimelineItem } from '../../api/memory-v2'
import Button from '../Button'

interface JobHealthProps {
  degraded: boolean
  warnings: string[]
  pendingJobs: Array<{ jobId: string; status: string; reasonCode?: string }>
  onRetry?: (jobId: string) => void
  summary?: MemorySummary
  timelineItem?: MemoryTimelineItem
}

export function JobHealth({
  degraded,
  warnings,
  pendingJobs,
  onRetry,
  summary,
  timelineItem,
}: JobHealthProps) {
  if (!degraded && warnings.length === 0 && pendingJobs.length === 0 && !summary && !timelineItem) {
    return null
  }
  return (
    <div className="space-y-2 rounded-lg border border-harbor-border bg-harbor-surface p-3">
      {degraded && (
        <p className="text-sm text-harbor-text-secondary">
          Showing PostgreSQL reads (semantic index unavailable).
        </p>
      )}
      {warnings.map((warning) => (
        <p key={warning} className="text-xs text-harbor-text-muted">
          {warning}
        </p>
      ))}
      {pendingJobs.map((job) => (
        <div key={job.jobId} className="flex items-center justify-between gap-2 text-sm">
          <span className="text-harbor-text">
            {job.jobId} · {job.status}
            {job.reasonCode && (
              <span className="ml-2 text-harbor-text-muted">{job.reasonCode}</span>
            )}
          </span>
          {onRetry && (
            <Button
              type="button"
              size="sm"
              variant="ghost"
              onClick={() => onRetry(job.jobId)}
              aria-label={`Retry job ${job.jobId}`}
            >
              Retry
            </Button>
          )}
        </div>
      ))}
      {summary && (
        <p className="text-xs text-harbor-text-muted">
          {summary.memoryId} · {summary.lifecycle} · index degraded
        </p>
      )}
      {timelineItem && <p className="text-xs text-harbor-text-muted">{timelineItem.summary}</p>}
    </div>
  )
}
